<section
    class="row co-steps"
    [ngClass]="{
        'co-steps--nkl': env === 'nkl',
        'co-steps--skl': env === 'skl'
    }"
>
    <a
        routerLink="/cart"
        routerLinkActive="active"
        [ngClass]="{ complete: isDisabled('step1') }"
        ><span>1</span> Losbestellung</a
    >
    <a
        routerLink="/bestellen/address"
        routerLinkActive="active"
        [ngClass]="{
            'co-steps__item--disabled': !isDisabled('step1'),
            complete: isDisabled('step2')
        }"
        ><span>2</span> Persönliche Daten & Zahlungsweise</a
    >
    <a
        routerLink="/bestellen/bestaetigung"
        routerLinkActive="active"
        [class.co-steps__item--disabled]="
            isDisabled('step2') && isDisabled('step1') ? null : true
        "
        ><span>3</span> Bestellung überprüfen</a
    >
</section>
